document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.benefit-item').forEach(function (slide) {
    slide.addEventListener('click', function () {
      const modalId = slide.querySelector('.fp-modal').getAttribute('data-modal-id');
      const modal = document.getElementById(modalId);

      if (modal) {
        document.body.style.overflowY = 'hidden';
        modal.classList.add('active');
      }
    });
  });

  // Prevent propagation when clicking the close button or overlay
  document.querySelectorAll('.fp-modal-close, .fp-modal-overlay').forEach(function (element) {
    element.addEventListener('click', function (event) {
      event.stopPropagation();
      const modal = this.closest('.fp-modal');
      if (modal) {
        document.body.style.overflowY = 'auto';
        modal.classList.remove('active');
      }
    });
  });
});
